import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import LocationPinIcon from '../icons/location-pin'
import PhoneIcon from '../icons/phone'
import * as styles from './contact-card.module.scss'
import classNames from 'classnames'
import EmailIcon from '../icons/email'

export default function ContactCard(props) {
  return (
    <div className="d-flex shadow-lg flex-column flex-md-row bg-white px-md-5 p-3 align-items-md-center">
      <div className={classNames('mb-3 mb-md-0 me-md-3 p-3', styles.imageWrapper)}>
        <img className={styles.image} src={props.image.file.url} alt={props.image.title} />
      </div>
      {props.place && (
        <div className="mb-3 mb-md-0 me-md-3">
          <h6 className="mb-3">{props.title}</h6>
          <div className={classNames(styles.itemWrapper)}>
            <LocationPinIcon className={styles.icon} />
            {props.place}
          </div>
        </div>
      )}
      {props.email && (
        <div className={classNames('mb-3 mb-md-0 me-md-3', styles.itemWrapper)}>
          <EmailIcon className={styles.icon} />
          {props.email}
        </div>
      )}
      {props.phoneNumber && (
        <div className={classNames('mb-3 mb-md-0 me-md-3', styles.itemWrapper)}>
          <PhoneIcon className={styles.icon} />
          {props.phoneNumber}
        </div>
      )}
    </div>
  )
}
ContactCard.propTypes = {
  email: PropTypes.string,
  image: PropTypes.shape({
    title: PropTypes.string,
    file: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }).isRequired,
  phoneNumber: PropTypes.string,
  title: PropTypes.string,
  place: PropTypes.string,
}

export const query = graphql`
  fragment ContactCardFragment on ContentfulWidgetCarteDeContact {
    __typename
    id: contentful_id
    email
    image {
      title
      file {
        url
      }
      id: contentful_id
    }
    phoneNumber
    title
    place
  }
`
